// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { getCartPropsFromState } from 'routes/cart/util';
import DeadlineWarning from 'routes/cart/components/deadline/DeadlineWarning';
import { getPartnerDisplayName } from 'routes/health/utils';

const mapStateToProps: Object = (state) => {
  const { contentfulData } = state;
  const deadlineTranslations = _.get(contentfulData, 'translations.cart.deadlineTranslations', {});
  const { healthApp } = getCartPropsFromState(state);
  const carrierName = _.get(healthApp, 'app_json.plan.carrier');
  const onExchange = _.get(healthApp, 'app_json.plan.onExchange', false);
  const stateName = _.get(contentfulData, 'name');
  const stateExchange = _.get(contentfulData, 'stateExchange', {});
  const isFFM = _.get(contentfulData, 'ffm', false);
  const partnerDisplayName = getPartnerDisplayName(state);

  return {
    carrierName,
    deadlineTranslations,
    isFFM,
    onExchange,
    stateExchange,
    stateName,
    partnerDisplayName,
  };
};

export default connect(mapStateToProps, {})(DeadlineWarning);
